export class SharedClientBase {
  toJSON() {
    return this.constructor.name; // Returns the class name
  }
}
